<template>
  <aside class="vp-message-inserts">
    <p class="vp-message-inserts__title">Message Inserts</p>
    <ul class="vp-message-inserts__actions">
      <vp-button v-for="(insert) in inserts" :key="insert.name" class="no-fill small blue" :disabled="previewMode || disabled" @click="insertVariable(insert)">{{ insert.prettyName }}</vp-button>
    </ul>
  </aside>
</template>

<script>
export default {
  name: 'VpMessageInserts',
  emits: ['insert-variable-clicked', 'modal-variable-clicked'],
  props: {
    inserts: { 
      type: Array, 
      default: () => [],
      validator: (inserts) => {
        const isValid = inserts.every((item) => 'name' in item && 'prettyName' in item);
        if (!isValid) console.error(`Invalid prop: each insert must include a 'name' and 'prettyName' property, Received`, { inserts });
        return isValid;
      }
    },
    previewMode: {
      type: [Boolean, Number],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    }
  },
  computed: {
    internalInserts() {

      let inserts = [
        { name: 'firstName', prettyName: 'First Name' },
        { name: 'fullName', prettyName: 'Full Name' },
        { name: 'date', prettyName: 'Date' },
      ];

      if (this.tab !== 'sms') {
        inserts = inserts.concat([
          { name: 'image', prettyName: 'Image' },
          { name: 'buttonLink', prettyName: 'Button Link' },
          { name: 'hyperlink', prettyName: 'Hyperlink' },
          { name: 'emailLink', prettyName: 'Email Address' },
        ]);
      }

      if (this.type === 'device-offline') {
        inserts = inserts.concat([
          { name: 'deviceUid', prettyName: 'Device UID' },
          { name: 'deviceMfg', prettyName: 'Manufacturer' },
          { name: 'deviceKind', prettyName: 'Device Kind' },
          { name: 'inactiveDays', prettyName: 'Inactive Days' },
        ]);
      }

      if (this.type === 'incentive-message') {
        inserts = inserts.concat([
          { name: 'claimURL', prettyName: 'Claim URL' },
          { name: 'claimPIN', prettyName: 'Claim PIN' },
          { name: 'reward', prettyName: 'Amount' },
          { name: 'expiryDate', prettyName: 'Expiry Date' },
          { name: 'expiryTime', prettyName: 'Expiry Time' },
        ]);
      }

      if (this.type === 'event') {
        inserts.splice(1, 5,
          { name: 'eventDate', prettyName: 'Event Date' },
          { name: 'eventTime', prettyName: 'Event Time' },
          { name: 'duration', prettyName: 'Duration' },
          { name: 'optout', prettyName: 'Optout' },
        );
      }

      if (this.type === 'behavioral-event') {
        inserts.splice(1, 5,
          { name: 'eventDate', prettyName: 'Event Date' },
          { name: 'eventTime', prettyName: 'Event Time' },
          { name: 'duration', prettyName: 'Duration' },
        );
      }

      return inserts;
    },
  },
  methods: {
    insertVariable(insert) {
      if (this.readonly) return null;
      if (insert.handler) {
        this.$emit('modal-variable-clicked', insert);
      } else {
        this.$emit('insert-variable-clicked', insert);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .vp-message-inserts {
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid #DBDBDB;
    & > * {
      gap: 1rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 1.25rem 0.75rem;
    }
    &__title {
      height: 70px;
      font-size: 1rem;
      background-color: #FBFBFB;
      border-radius: 6px 6px 0 0;
      border-bottom: 1px solid #DBDBDB;
    }
    &__actions {
      margin: 0;
      height: 100%;
      overflow-y: auto;
      max-height: calc(calc(50px * 5.1));
    }
  }
</style>